// General
import "./last-stream-top-gifters.scss";
import { useEffect } from "react";
// Services
import { useLazyGetLastStreamResultQuery } from "../../../../../services/data.service";
// Static Data
import routeConst from "../../../../../const/routeConst";
import userConst from "../../../../../const/userConst";
// Redux
import { useDispatch } from "react-redux";
import {
  updateId,
  updateIdInt,
  updateUsername,
  updateAge,
  updateGender,
  updateLocation,
  updateMembershipType,
  updateVerifiedProfile,
  updateVerifiedCaller,
  updateLevellingBadge,
  updateLivestreamingAchievementBadge,
  updateSpecialBadges,
  updateProfilePhoto,
  updatePublicPhotos,
  updatePrivatePhotos,
  updateTorTags,
  updateProfileAchievementBadge,
  updateAboutMe,
  updateAboutMeManualText,
  updateAboutMeReadStatus,
  updateLookingFor,
  updateOccupation,
  updateLifestyle,
  updateEducation,
  updateRelationship,
  updateSmoking,
  updateDrinking,
  updateHeight,
  updateBodyType,
  updateEthnicity,
  updateEyeColor,
  updateHairColor,
  updateChildren,
  // About Me Functions
  updatePersonalityType,
  updateHobbies,
  updateStarSign,
  updateFitnessLevel,
  updateDominantOrSubmissive,
  updatePersonalityTraits,
  // Looking For Functions
  updateLookingForAgeRange,
  updateLookingForLocation,
  updateLookingForEthnicityRace,
  // User Utility
  updateShouldCallApi,
  updatePrivatePhotoRequested,
  updatePrivatePhotoApproval,
  updateRequestedMyPrivatePhoto,
  updateApprovedMyPrivatePhoto,
  updateIsBlocked,
  updateIsSilentInteraction,
  updateIsFavorited,
  updateIsCallEnabled,
  updateIsSugarbaby,
  updateRole,
} from "../../../../../redux/store/userCardStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../../../utility/custom-hooks/useCustomNavigate-hook";
import IconManager from "../../../../utility/manager/icon-manager/icon-manager";
// Components
import CustomAvatar from "../../../../shared/elements/custom-avatar/custom-avatar";
import Spinner from "../../../../shared/elements/spinner/spinner";

const LastStreamTopGifters = () => {
  // API variables
  const [
    getLastStreamSummary,
    {
      data: getLastStreamSummaryData,
      error: getLastStreamSummaryErrorData,
      isFetching: getLastStreamSummaryFetching,
      isLoading: getLastStreamSummaryLoading,
      isSuccess: getLastStreamSummarySuccess,
      isError: getLastStreamSummaryError,
    },
  ] = useLazyGetLastStreamResultQuery();

  // Redux variables
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();
  const getIcon = IconManager();

  // Lifecycle | Mounted
  useEffect(() => {
    getLastStreamSummary(null, true);
  }, []);

  // Event Handlers | Button
  const onViewProfile = (gifter) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-28-28.1-Button",
      },
    });

    // User View
    dispatch(updateId(gifter?.id));
    dispatch(updateIdInt(gifter?.id_int));
    dispatch(updateUsername(gifter?.username));
    dispatch(updateAge(gifter?.appearance?.age));
    dispatch(updateGender(gifter?.gender));
    dispatch(updateLocation(gifter?.location?.city || gifter?.location?.state));
    dispatch(updateMembershipType(gifter?.membership_type));
    dispatch(updateVerifiedProfile(gifter?.is_verified_profile));
    dispatch(updateVerifiedCaller(gifter?.verified_caller));
    dispatch(updateLevellingBadge(gifter?.levelling_profile?.badge));
    dispatch(
      updateLivestreamingAchievementBadge(
        gifter?.live_streaming_achievements?.chat_badges_set
      )
    );
    dispatch(updateSpecialBadges(gifter?.special_badges));
    dispatch(updateProfilePhoto(gifter?.profile_photo?.original_photo));
    dispatch(
      updatePublicPhotos(
        gifter?.public_photos?.map((photo) => {
          return {
            photoUrl: photo?.original_photo,
          };
        })
      )
    );
    dispatch(
      updatePrivatePhotos(
        gifter?.private_photos?.map((photo) => {
          return {
            photoUrl: photo?.original_photo,
            thumbnailData: photo?.thumbnail_data,
            isSensitive: photo?.is_sensitive,
          };
        })
      )
    );
    dispatch(updateTorTags(gifter?.tor_tags));
    dispatch(
      updateProfileAchievementBadge(
        gifter?.live_streaming_achievements?.profile_badges
      )
    );
    dispatch(updateAboutMeManualText(gifter?.aboutme));
    dispatch(updateAboutMeReadStatus(gifter?.aboutme_read_status));
    dispatch(updateLookingFor(gifter?.interest));
    dispatch(updateOccupation(gifter?.occupation?.occupation));
    dispatch(updateLifestyle(gifter?.occupation?.lifestyle_budget));
    dispatch(updateEducation(gifter?.occupation?.education));
    dispatch(updateRelationship(gifter?.relationship?.relationship_status));
    dispatch(updateSmoking(gifter?.habit?.smoking));
    dispatch(updateDrinking(gifter?.habit?.drinking));
    dispatch(updateHeight(gifter?.appearance?.height));
    dispatch(updateBodyType(gifter?.appearance?.body_type));
    dispatch(updateEthnicity(gifter?.appearance?.ethnicity));
    dispatch(updateEyeColor(gifter?.appearance?.eye_color));
    dispatch(updateHairColor(gifter?.appearance?.hair_color));
    dispatch(updateChildren(gifter?.relationship?.children));
    // About Me Functions
    const personalityType = gifter?.personality?.personality_type;
    const hobbies = gifter?.habit?.hobbies;
    const starSign = gifter?.personality?.star_sign;
    const fitnessLevel = gifter?.habit?.fitness_level;
    const dominantOrSubmissive = gifter?.personality?.dominant_or_submissive;
    const personalityTraits = gifter?.personality?.personality_traits;

    let tempAboutMeList = [];

    tempAboutMeList?.push({
      name: "personality_type",
      data: personalityType?.length > 0 ? personalityType : null,
    });
    tempAboutMeList?.push({
      name: "hobbies",
      data: hobbies?.lengtj > 0 ? hobbies : null,
    });
    tempAboutMeList?.push({
      name: "star_sign",
      data: starSign,
    });
    tempAboutMeList?.push({
      name: "fitness_level",
      data: fitnessLevel,
    });
    tempAboutMeList?.push({
      name: "dominant_or_submissive",
      data: dominantOrSubmissive,
    });
    tempAboutMeList?.push({
      name: "personality_traits",
      data: personalityTraits,
    });
    dispatch(updatePersonalityType(personalityType));
    dispatch(updateHobbies(hobbies));
    dispatch(updateFitnessLevel(fitnessLevel));
    dispatch(updateStarSign(starSign));
    dispatch(updateDominantOrSubmissive(dominantOrSubmissive));
    dispatch(updatePersonalityTraits(personalityTraits));

    dispatch(updateAboutMe(tempAboutMeList));

    dispatch(
      updateLookingForAgeRange({
        min: gifter?.looking_fors?.age?.min,
        max: gifter?.looking_fors?.age?.max,
      })
    );
    dispatch(updateLookingForLocation(gifter?.looking_fors?.locations));
    const temp = gifter?.looking_fors?.ethnicity?.map((item) => ({
      ethnicity: {
        id: item?.option?.id,
        locale: item?.option?.locale,
        display_locale: item?.option?.locale,
      },
      race: item?.sub_option
        ? {
            id: item?.sub_option?.id,
            locale: item?.sub_option?.locale,
            display_locale: item?.sub_option?.locale,
          }
        : null,
    }));
    dispatch(updateLookingForEthnicityRace(temp));

    // User Utility
    dispatch(updateShouldCallApi(true));
    dispatch(
      updatePrivatePhotoRequested(gifter?.interaction?.private_photo_requested)
    );
    dispatch(
      updatePrivatePhotoApproval(gifter?.interaction?.private_photo_approval)
    );
    dispatch(
      updateRequestedMyPrivatePhoto(
        gifter?.interaction?.requested_my_private_photo
      )
    );
    dispatch(
      updateApprovedMyPrivatePhoto(
        gifter?.interaction?.approved_my_private_photo
      )
    );
    dispatch(updateIsBlocked(gifter?.interaction?.is_blocked ? true : false));
    dispatch(
      updateIsSilentInteraction(gifter?.interaction?.should_silent_interactions)
    );
    dispatch(updateIsFavorited(gifter?.interaction?.is_favorited));
    dispatch(
      updateIsCallEnabled(
        gifter?.private_call_settings?.enable_calls &&
          gifter?.private_call_settings?.system_private_calls_enabled
      )
    );
    dispatch(
      updateIsSugarbaby(
        gifter?.role === userConst.userRole.sugarbaby ||
          gifter?.role === userConst.userRole.maleSugarbaby
      )
    );
    dispatch(updateRole(gifter?.role));

    onNavigate(`${routeConst.profile.view.clearPath}${gifter?.id}`);
  };

  if (getLastStreamSummaryFetching || getLastStreamSummaryLoading) {
    return <Spinner />;
  } else if (getLastStreamSummarySuccess) {
    if (getLastStreamSummaryData?.status === 1) {
      if (getLastStreamSummaryData?.data?.top_gifters?.length > 0) {
        return (
          <div id="last-stream-summary-last-stream-top-gifters-subcomponent">
            <div className="padding-container">
              <div className="top-gifters-label">
                {t("leaderboard.top_gifters")}
              </div>

              <div className="top-gifters-container">
                {getLastStreamSummaryData?.data?.top_gifters?.map(
                  (gifter, index) => (
                    <div className="gifter-container" key={index}>
                      <CustomAvatar
                        className="gifter-photo"
                        src={gifter?.profile_photo?.original_photo}
                        role={gifter?.role}
                        profileBorder={
                          gifter?.profile_decorations?.profile_border_url
                        }
                        onClick={() => onViewProfile(gifter)}
                      />

                      <div className="gifter-position">
                        {index === 0 &&
                          getIcon("leaderboardRank1", "badge-ranking")}
                        {index === 1 &&
                          getIcon("leaderboardRank2", "badge-ranking")}
                        {index === 2 &&
                          getIcon("leaderboardRank3", "badge-ranking")}
                      </div>

                      <div className="gifter-username">{gifter?.username}</div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        );
      }
    }
  } else if (getLastStreamSummaryError) {
  }
};

export default LastStreamTopGifters;
